// extracted by mini-css-extract-plugin
export var actions = "_t8-4";
export var item = "_t8-1";
export var price = "_t8-3";
export var quantity = "_t8-2";
export var table = "_t8-0";